<!-- prettier-ignore -->

<button
  class="chat__button"
  type="submit"
  [disabled]="isInvalid()"
  [attr.aria-label]="'Enviar mensaje' | translate"
>
  <icon-send />
</button>
